import { AuthServiceInterface } from '@/services/interface/AuthService.js'
import { backendClient, contractClient } from '@/plugins/apollo'
import { GET_AUTH, GET_USER_INFO } from '@/graphql/Auth'

export class BackendAuthService extends AuthServiceInterface {
  static async authenticate (login, password) {
    return backendClient.query({ query: GET_AUTH, variables: { login, password }, fetchPolicy: 'network-only' })
      .then(({ data: { auth: data } }) => {
        return data
      }).catch((e) => {
        console.log('authentication error', e)
      })
  }

  static async userInfo () {
    return backendClient.query({ query: GET_USER_INFO })
  }

  static async logout () {
    contractClient.resetStore()
    return backendClient.resetStore()
  }
}
